module.exports = __webpack_public_path__ + "img/1.7db95e55.png";